// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__8qNqC","tabContainer":"navbar_tabContainer__lcvkd"};